module.exports = __webpack_public_path__ + "static/media/study220411.d9976495.png";